import cloneDeep from "lodash/cloneDeep";
import each from "lodash/each";
import get from "lodash/get";
import set from "lodash/set";
import moment from "moment";
import compOperations from "../../comp/ducks/operations";
import { request } from "../../utils/axios-wrapper";
import { pageSize } from "../../utils/constants";
import utils from "../../utils/index";
import utilOperations from "../../utils/operations";
import constants from "../constants";
import dealsTables from "../dealsTables";
import actions from "./actions";

const getDeals = (url, tab) => {
    return (dispatch, getState) => {
        const { dealsPage, dealsSort, dealsFilter } = getState().dealsReducer;
        dispatch(utils.actions.somethingSaving(true, tab));
        dispatch(utils.actions.loading(true));
       
        const params = new URLSearchParams({
            page: dealsPage - 1,
            size: pageSize,
        });
        
        if (dealsSort) {
            params.append("sort", dealsSort);
        }
        
        params.append("sort", "id,desc");
        
        if (dealsFilter?.field) {
            if (dealsFilter.type === "currency" && dealsFilter.currencyFrom && dealsFilter.currencyTo) {
                params.append("filterColumn", dealsFilter.field);
                params.append(dealsFilter.field + "From", dealsFilter.currencyFrom);
                params.append(dealsFilter.field + "To", dealsFilter.currencyTo);
            } else if (dealsFilter.type === "numberRange" && dealsFilter.numberRangeFrom && dealsFilter.numberRangeTo) {
                params.append("filterColumn", dealsFilter.field);
                params.append(dealsFilter.field + "From", dealsFilter.numberRangeFrom);
                params.append(dealsFilter.field + "To", dealsFilter.numberRangeTo);
            } else if (dealsFilter.type === "date" && dealsFilter.dateFrom && dealsFilter.dateTo) {
                params.append("filterColumn", dealsFilter.field);
                params.append("dateFrom", dealsFilter.dateFrom);
                params.append("dateTo", dealsFilter.dateTo);
            } else if (dealsFilter.value) {
                params.append("filterColumn", dealsFilter.field);
                params.append("filterValue", dealsFilter.value.trim());
            }
        }

        request(
            {
                url: `${url}?${params}`,
                method: "get",
                crossDomain: true,
            },
            dispatch
        )
            .then((response) => {
                dispatch(actions.receiveVouchers(response.data, tab));
                dispatch(utils.actions.somethingSaving(false, tab));
                dispatch(utils.actions.loading(false));
            })
            .catch((err) => {
                dispatch(utils.actions.somethingSaving(false, tab));
                dispatch(utilOperations.reportError(err, "deals:operations:getDeals(inner) Error"));
                dispatch(utils.actions.loading(false));
            });
    };
};

const resetDealsTab = () => {
    return (dispatch) => {
        dispatch(actions.setDealsPage(1));
        dispatch(actions.setDealsSort(null));
        dispatch(actions.setDealsFilter(null));
    };
};

const setDealsPage = (page) => {
    return (dispatch) => {
        dispatch(actions.setDealsPage(page));
    };
};

const setDealsSort = (sort) => {
    return (dispatch) => {
        dispatch(actions.setDealsSort(sort));
    };
};

const setDealsFilter = (filter) => {
    return (dispatch) => {
        dispatch(actions.setDealsFilter(filter));
    };
};



const switchVoucherView = (tab) => {
    return (dispatch, getState) => {
        dispatch(actions.switchVoucherView(tab));
        if (!getState().dealsReducer.deals[tab] || dealsTables.refreshTabOnSwitch(tab)) {
            dispatch(getDeals(constants.urls[tab](getState().authReducer.userProfile.user), tab));
        }
    };
};

const switchTab = (tab) => {
    return (dispatch, getState) => {
        dispatch(actions.switchVoucherView(tab));
    };
};

const handleCheckboxClick = (id) => {
    return (dispatch, getState) => {
        const selected = getState().dealsReducer.selected;
        let newSelected = [];
        if (selected) {
            const selectedIndex = selected.indexOf(id);
            if (selectedIndex === -1) {
                newSelected = newSelected.concat(selected, id);
            } else if (selectedIndex === 0) {
                newSelected = newSelected.concat(selected.slice(1));
            } else if (selectedIndex === selected.length - 1) {
                newSelected = newSelected.concat(selected.slice(0, -1));
            } else if (selectedIndex > 0) {
                newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
            }
        } else {
            newSelected.push(id);
        }
        dispatch(actions.checkboxClick(newSelected));
    };
};

const handleStartReviewingAsCorporateData = (deal, currentPath) => {
    return (dispatch, getState) => {
        const dealKey = deal?.dealKey ?? deal?.id;
        const url =
            deal.compStatus === "Closed"
                ? constants.urls.assign_voucher_for_review_by_deal_id(dealKey)
                : constants.urls.assign_comp_for_review(dealKey);
        return request(
            {
                method: "put",
                url: url,
            },
            dispatch
        )
            .then((response) => {
                /* 
                    This function is only called from inside /comp/:id. 
                    The samePath constant is used for the case where we need to update
                    the current page's state without redirecting the user. We do this by calling
                    the getDeal operation, which updates the deal reducer.
                */

                const samePath = currentPath === `/comp/${dealKey}`;
                if (samePath) {
                    dispatch(compOperations.getDeal(dealKey));
                    return { dealKey: response.data.dealKey };
                } else {
                    return { voucherKey: response.data.voucherKey };
                }
            })
            .catch((err) => {
                dispatch(utils.actions.snackbar(true, "error", "Error occured while trying to start reviewing deal"));
            });
    };
};

const toggleReviewedBy = (processed, dealKey, tab) => {
    return (dispatch, getState) => {
        request(
            {
                method: "put",
                url: constants.urls.toggleReviewedBy(dealKey),
                data: processed
                    ? {
                          reviewedBy: null,
                          reviewedDate: null,
                      }
                    : {
                          reviewedBy: getState().authReducer.userProfile.user,
                          reviewedDate: moment().format("YYYY-MM-DD HH:mm"),
                      },
                headers: { "Content-Type": "application/json" },
            },
            dispatch
        )
            .then((response) => {
                dispatch(markAsReviewed(response.data, tab));
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const markAsReviewed = (data, tab) => {
    return (dispatch, getState) => {
        let deals = cloneDeep(getState().dealsReducer.deals[tab]);
        each(deals, (deal) => {
            if (deal.dealKey === get(data, "dealKey")) {
                set(deal, "reviewedBy", data.reviewedBy);
                set(deal, "reviewedDate", data.reviewedDate);
            }
        });
        dispatch(actions.receiveVouchers(deals, tab));
    };
};

export default {
    switchVoucherView,
    handleCheckboxClick,
    getDeals,
    handleStartReviewingAsCorporateData,
    switchTab,
    toggleReviewedBy,
    setDealsPage,
    setDealsSort,
    setDealsFilter,
    resetDealsTab,
};
